/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 14:51:10
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-14 10:55:49
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/Availability/index.tsx
 */
import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

import {
  onLinkedSalesChannelsProductsChange,
  getLinkedSalesChannels,
  EnumCollapseId,
  onLinkedSalesChannelsProductsDelete,
} from '../slice';
import AvailableTable from '@/src/pages/ProductEditor/Components/SalesChannelAvailablity';
import SectionHOC from '../HOC';
import { getI18nFromGeneral } from '@/src/tools/tools';

const Available = (props) => {
  const data = useSelector(getLinkedSalesChannels());
  const _d = useDispatch();
  const handleOnProductsChange = (p) => {
    _d(onLinkedSalesChannelsProductsChange(p));
  };
  const handleOnProductDelete = (data) => {
    _d(onLinkedSalesChannelsProductsDelete(data));
  };
  return (
    <React.Fragment>
      {/* {Test('321')} */}
      {/* <Test haha={123} />; */}
      <AvailableTable
        disabled={props.disabled}
        data={data}
        onProductsAdd={handleOnProductsChange}
        onProductDelete={handleOnProductDelete}
      />
    </React.Fragment>
  );
};
export default SectionHOC(Available, {
  useDefaultCollapseContent: true,
  title: getI18nFromGeneral('general.hOCTitle.salesChannelAvailability'),
  id: EnumCollapseId.SalesChannelAvailability,
});
